const filterOpener = document.querySelector('.filter-opener');
const filters = document.querySelector('.filters');

filterOpener?.addEventListener('click', function () {
  filters.classList.toggle('show');
})